export default "__VITE_ASSET__YVYgcxlB__"